import { render, staticRenderFns } from "./Ordini.vue?vue&type=template&id=17a41a9d&scoped=true"
import script from "./Ordini.vue?vue&type=script&lang=ts"
export * from "./Ordini.vue?vue&type=script&lang=ts"
import style0 from "./Ordini.vue?vue&type=style&index=0&id=17a41a9d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a41a9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a41a9d')) {
      api.createRecord('17a41a9d', component.options)
    } else {
      api.reload('17a41a9d', component.options)
    }
    module.hot.accept("./Ordini.vue?vue&type=template&id=17a41a9d&scoped=true", function () {
      api.rerender('17a41a9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Ordini.vue"
export default component.exports